export const isDev = () => window.process.env.NODE_CONFIG_ENV === 'development';

export const isPre = () => window.process.env.NODE_CONFIG_ENV === 'staging';

export const isProd = () => window.process.env.NODE_CONFIG_ENV === 'production';
